import { Mqtt_Topics_studyChanges } from "../RAWMap.Models/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Msg } from "./StudyTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_studyChanges(uid)), (Item) => (new Msg(27, [Item]))];
}

